<template>
    <div class="g-content">
        <div style="padding: 20px">
            <!-- default-expand-all是控制树形数据的展开和折叠的 -->
            <el-table :data="list" style="width: 100%" row-key="id" :stripe="true" 
                :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }"
                :header-cell-style="{ background: '#fafafa', color: '#333' }">
                <el-table-column prop="name" label="名称" width="400" align="center" />
                <el-table-column prop="displayOrder" label="显示顺序"  align="center"/>
                <el-table-column :key="9" label="操作" width="160" class="f-tar" align="center">
                    <template slot-scope="scope">
                        <div class="f-tar">
                            <!-- 三级以上不渲染新增数据 -->
                            <template v-if="scope.row.level < 3">
                                <el-button slot="reference" type="text" size="small"
                                    @click="subAddHandle(scope.row)">添加子级</el-button>
                                <span class="u-split">|</span>
                            </template>
                            <el-button type="text" size="small" @click="editHandle(scope.row)">编辑</el-button>
                            <span class="u-split">|</span>
                            <!-- <el-popover
                                    placement="top"
                                    width="160"
                                    v-model="scope.row.visible"
                                    trigger="manual"
                                    >
                                    <p>您确定要删除吗？</p>
                                    <br />
                                    <div style="text-align: right; margin: 0">
                                        <el-button
                                        size="mini"
                                        type="text"
                                        @click="scope.row.visible = false"
                                        >取消</el-button
                                        >
                                        <el-button
                                        type="primary"
                                        size="mini"
                                        @click="
                                            scope.row.visible = false;
                                            delItem(scope.row);
                                        "
                                        >确定</el-button
                                        >
                                    </div>
                                    <el-button
                                        slot="reference"
                                        type="text"
                                        size="small"
                                        style="color: #d9001b"
                                        @click="scope.row.visible = true"
                                        >删除</el-button
                                    >
                             </el-popover> -->
                            <el-popover :ref="`popover-${scope.$index}`" trigger="click" visible-arrow="false"
                                placement="top">
                                <p style="text-align: right; margin-bottom: 15px">您确定要删除吗？</p>
                                <div style="margin:0 auto;text-align: center;">
                                    <el-button size="mini" type="text"
                                        @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">取消</el-button>
                                    <el-button type="primary" size="mini" @click="delItem(scope)">确定</el-button>
                                </div>
                                <span slot="reference" style="color: #d9001b;cursor: pointer;;font-size: 12px;">删除
                                </span>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="my-page">
            <el-pagination hide-on-single-page background :current-page="page" :page-sizes="[10, 20, 30, 40]"
                :page-size="size" layout="total,  prev, pager, next, sizes, jumper" :total="totalCount"
                @size-change="changePageSize" @current-change="changePage" />
        </div>
        <div style="height:20px"></div>

        <Add :title="title" :show="showForm" :edit-info="editInfo" :add-show-index="addShowIndex" @close="
            showForm = false;
        editInfo = null;
        " @finish="init" />
        <AddSub :title="subTitle" :show="showSub" :info="subInfo" :edit-info="subEditInfo" :add-show-index="subAddShowIndex"
            @close="
                showSub = false;
            subEditInfo = null;
            " @finish="init" />
    </div>
</template>
  
<script>
import Add from './comIndex2/add'
import AddSub from './comIndex2/add-sub.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'SetCategory',
    components: {
        Add,
        AddSub
    },
    props: {
        searchField: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            title: '新增参展品类',
            subTitle: '添加子类',
            subInfo: null,
            editInfo: null,
            subEditInfo: null,
            showForm: false,
            showSub: false,
            addShowIndex: 0,
            subAddShowIndex: 0,

            page: 1,
            size: 10,
            totalCount: 0,
            list: [],

            parent: []
        }
    },
    watch: {},
    computed: {
        ...mapGetters({
            user: 'getUserInfo',
            group: 'getGroup'
        }),
        option () {
            const opt = {
                page: this.page,
                size: this.size,
                groupId: this.group.id || '',
                name: this.searchField
            }
            return opt
        }
    },
    mounted () {
        this.init()
    },
    methods: {
        ...mapActions({
            setManageUpdate: 'hostSetModule/setManageUpdate', // 
            setManageSettingQ: 'hostSetModule/setManageSettingQ', //
            exhibition: "hostSetModule/getHostExhibition",
            joinProductId: "hostSetModule/joinProductId",
            categoryDelete: "hostSetModule/categoryDelete"
        }),
        async init () {
            const res = await this.joinProductId()
            if (res && res.length) {
                res.map((c) => {
                    c.level = 1
                    c.visible = false
                    if (c.childrens.length) {
                        c.childrens.map((v) => {
                            v.level = 2
                            v.visible = false
                            if (v.childrens.length) {
                                v.childrens.map((j) => {
                                    j.level = 3
                                    j.visible = false
                                })
                            }
                        })
                    }
                })
                this.list = res
            }
        },
        changePage (e) {
            this.page = e
            this.init()
        },
        changePageSize (e) {
            this.size = e
            this.init()
        },
        async delItem (info) {
            info._self.$refs[`popover-${info.$index}`].doClose()
            
            const res = await this.categoryDelete( info.row.id )
            if (res) {
                this.$notify({
                    title: '成功',
                    message: '操作成功！',
                    type: 'success'
                })
                this.init()
            } else {
                this.$notify.error({
                    title: '错误',
                    message: '操作失败，请重新尝试！'
                })
            }
        },
        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid)
                })
            })
        },
        addHandle () {
            
            this.showForm = true
            this.title = '新增参展品类'
            this.addShowIndex = this.list.length + 1
            console.log('showForm', this.showForm)
        },
        editHandle (e) {
           
            if (e.level === 1) {
                console.log(e)
                this.title = '编辑参展品类'
                this.editInfo = e
                this.showForm = true
            } else {
                this.editSubShow(e)
            }
        },
        subAddHandle (e) {
           
            this.subTitle = '添加子类'
            this.subAddShowIndex = e.childrens.length
            this.subInfo = e
            this.showSub = true
        },
        editSubShow (row) {
            let parent = null
            this.list.forEach((item) => {
                if (item.id === row.parentId) {
                    parent = item
                } else {
                    item.childrens.forEach((c) => {
                        if (c.id === row.parentId) {
                            parent = c
                            return
                        }
                    })
                }
            })
            this.subTitle = '编辑子类'
            this.subEditInfo = row
            this.subInfo = parent
            this.showSub = true
        },
        async synchron () {
            if (!this.rolesUtils.rolesVer('systemSet.necessary.category.synchronize')) {
                return
            }
            const opt = {
                groupId: this.group.id || '',
            }

            let res = await this.CategoryToBlob(opt)
            console.log(res);
            if (res) {
                this.$notify({
                    title: '成功',
                    message: '同步数据成功！',
                    type: 'success'
                })
            } else {
                this.$notify.error({
                    title: '错误',
                    message: '操作失败，请重新尝试！'
                })
            }
        },
    }
}
</script>
  
<style lang="scss" scoped></style>
  